var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_744_3429",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.25 18.25V1.74994H1.74994V18.25H18.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_744_3429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9139 3.10933V16.8906C16.9139 17.6673 16.2843 18.2969 15.5077 18.2969H4.49201C3.71537 18.2969 3.08575 17.6673 3.08575 16.8906V3.10933C3.08575 2.33265 3.71537 1.70307 4.49201 1.70307H15.5077C16.2843 1.70307 16.9139 2.33265 16.9139 3.10933Z",
    stroke: "#293755",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9139 3.10933V16.8906C16.9139 17.6673 16.2843 18.2969 15.5077 18.2969H4.49201C3.71537 18.2969 3.08575 17.6673 3.08575 16.8906V3.10933C3.08575 2.33265 3.71537 1.70307 4.49201 1.70307H15.5077C16.2843 1.70307 16.9139 2.33265 16.9139 3.10933Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9139 3.10933V16.8906C16.9139 17.6673 16.2843 18.2969 15.5077 18.2969H4.49201C3.71537 18.2969 3.08575 17.6673 3.08575 16.8906V3.10933C3.08575 2.33265 3.71537 1.70307 4.49201 1.70307H15.5077C16.2843 1.70307 16.9139 2.33265 16.9139 3.10933Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9139 3.10933V16.8906C16.9139 17.6673 16.2843 18.2969 15.5077 18.2969H4.49201C3.71537 18.2969 3.08575 17.6673 3.08575 16.8906V3.10933C3.08575 2.33265 3.71537 1.70307 4.49201 1.70307H15.5077C16.2843 1.70307 16.9139 2.33265 16.9139 3.10933Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9139 3.10933V16.8906C16.9139 17.6673 16.2843 18.2969 15.5077 18.2969H4.49201C3.71537 18.2969 3.08575 17.6673 3.08575 16.8906V3.10933C3.08575 2.33265 3.71537 1.70307 4.49201 1.70307H15.5077C16.2843 1.70307 16.9139 2.33265 16.9139 3.10933Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9139 3.10933V16.8906C16.9139 17.6673 16.2843 18.2969 15.5077 18.2969H4.49201C3.71537 18.2969 3.08575 17.6673 3.08575 16.8906V3.10933C3.08575 2.33265 3.71537 1.70307 4.49201 1.70307H15.5077C16.2843 1.70307 16.9139 2.33265 16.9139 3.10933Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9139 3.10933V16.8906C16.9139 17.6673 16.2843 18.2969 15.5077 18.2969H4.49201C3.71537 18.2969 3.08575 17.6673 3.08575 16.8906V3.10933C3.08575 2.33265 3.71537 1.70307 4.49201 1.70307H15.5077C16.2843 1.70307 16.9139 2.33265 16.9139 3.10933Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9139 3.10933V16.8906C16.9139 17.6673 16.2843 18.2969 15.5077 18.2969H4.49201C3.71537 18.2969 3.08575 17.6673 3.08575 16.8906V3.10933C3.08575 2.33265 3.71537 1.70307 4.49201 1.70307H15.5077C16.2843 1.70307 16.9139 2.33265 16.9139 3.10933Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9139 3.10933V16.8906C16.9139 17.6673 16.2843 18.2969 15.5077 18.2969H4.49201C3.71537 18.2969 3.08575 17.6673 3.08575 16.8906V3.10933C3.08575 2.33265 3.71537 1.70307 4.49201 1.70307H15.5077C16.2843 1.70307 16.9139 2.33265 16.9139 3.10933Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9139 3.10933V16.8906C16.9139 17.6673 16.2843 18.2969 15.5077 18.2969H4.49201C3.71537 18.2969 3.08575 17.6673 3.08575 16.8906V3.10933C3.08575 2.33265 3.71537 1.70307 4.49201 1.70307H15.5077C16.2843 1.70307 16.9139 2.33265 16.9139 3.10933Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.23422 1.7031V4.46875H12.7655V1.7031",
    stroke: "#293755",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23422 1.7031V4.46875H12.7655V1.7031",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23422 1.7031V4.46875H12.7655V1.7031",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23422 1.7031V4.46875H12.7655V1.7031",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23422 1.7031V4.46875H12.7655V1.7031",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23422 1.7031V4.46875H12.7655V1.7031",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23422 1.7031V4.46875H12.7655V1.7031",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23422 1.7031V4.46875H12.7655V1.7031",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23422 1.7031V4.46875H12.7655V1.7031",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23422 1.7031V4.46875H12.7655V1.7031",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 8.61719H7.23423",
    stroke: "#293755",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 8.61719H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 8.61719H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 8.61719H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 8.61719H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 8.61719H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 8.61719H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 8.61719H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 8.61719H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 8.61719H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 8.61719H9.99982",
    stroke: "#293755",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 8.61719H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 8.61719H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 8.61719H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 8.61719H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 8.61719H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 8.61719H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 8.61719H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 8.61719H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 8.61719H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 11.3828H7.23423",
    stroke: "#293755",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 11.3828H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 11.3828H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 11.3828H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 11.3828H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 11.3828H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 11.3828H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 11.3828H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 11.3828H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 11.3828H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 11.3828H9.99982",
    stroke: "#293755",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 11.3828H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 11.3828H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 11.3828H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 11.3828H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 11.3828H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 11.3828H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 11.3828H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 11.3828H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 11.3828H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 14.1484H7.23423",
    stroke: "#293755",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 14.1484H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 14.1484H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 14.1484H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 14.1484H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 14.1484H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 14.1484H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 14.1484H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 14.1484H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54285 14.1484H7.23423",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 14.1484H9.99982",
    stroke: "#293755",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 14.1484H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 14.1484H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 14.1484H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 14.1484H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 14.1484H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 14.1484H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 14.1484H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 14.1484H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 14.1484H9.99982",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/Frame (1).1efa0ce5e35c7a50d0ba94a5dadaf8ad.svg";
export { ForwardRef as ReactComponent };